import React, {Fragment} from 'react';
import Collapsible from 'react-collapsible';
import {classNamesPrefixed} from '../../../helpers/CoreHelpers';
import {collapsibleSettings} from '../../helpers/Helpers';
import InputWrap from "./InputWrap";

const TextareaField = (props) => {
    const {input, omitCollapsible, label, placeholder, meta: {touched, error}, expanded} = props;

    const inputWrapProps = {
        ...props,
    };

    const content = (
        <InputWrap {...inputWrapProps}>
            <textarea {...input} placeholder={placeholder}/>
            {touched && error && <div className={classNamesPrefixed({'input-below-error': true})}>{error}</div>}
        </InputWrap>
    );

    return (
        <Fragment>
            {omitCollapsible ? (
                <div>{content}</div>
            ) : (
                <Collapsible
                    {...collapsibleSettings}
                    trigger={label ? <label className={classNamesPrefixed({"trigger__label":true})}>{label}</label> : ''}
                    open={expanded}
                >
                    {content}
                </Collapsible>
            )}
        </Fragment>
    );
};

export default TextareaField;


// WEBPACK FOOTER //
// ./src/core/admin/components/Fields/TextareaField.js